import React, { useEffect, useMemo, useRef, useState } from 'react';
import JoditEditor from 'jodit-react';

const EmailComponent = ({ formData, setFormData }) => {
  const editor = useRef(null);
  const [content, setContent] = useState(formData?.template_content || '');
  const [dirty, setDirty] = useState(false);

  // Keep editor in sync with incoming template content, but never overwrite once user starts editing.
  useEffect(() => {
    if (!dirty) {
      setContent(formData?.template_content || '');
    }
  }, [formData?.template_content, dirty]);

  const config = useMemo(
    () => ({
      readonly: false,
      height: 400,
      toolbarAdaptive: false,
      showCharsCounter: false,
      showWordsCounter: false,
      showXPathInStatusbar: false,
      toolbarSticky: false,
      // Paste behavior: no popup, clean HTML automatically
      askBeforePasteHTML: false,
      defaultActionOnPaste: 'insert_clear_html',
      enter: 'P',
      nl2br: false,
      cleanHTML: {
        fillEmptyParagraph: false,
      },
      buttons: [
        'bold', 'italic', 'underline', '|',
        'ul', 'ol', '|',
        'outdent', 'indent', '|',
        'font', 'fontsize', 'brush', 'paragraph', '|',
        'image', 'video', 'table', 'link', '|',
        'align', 'undo', 'redo', '|',
        'hr', 'copyformat', 'symbol', 'print', 'about', '|',
        'fullsize', 'source'
      ]
    }),
    []
  );

  return (
    <div>
      <JoditEditor
        ref={editor}
        value={content}
        config={config}
        onChange={(newContent) => {
          setDirty(true);
          setContent(newContent);
          setFormData((prev) => ({ ...prev, template_content: newContent }));
        }}
        onBlur={(newContent) => {
          // Keep blur as a final sync point (some browsers/editors apply changes on blur).
          setDirty(true);
          setContent(newContent);
          setFormData((prev) => ({ ...prev, template_content: newContent }));
        }}
      />
    </div>
  );
};
export default EmailComponent;
